import { useEffect, useState } from "react";
import "./ChatForm.css";
import type {
  IChatFormProps,
  ChatFormTabs,
  IClientData,
} from "./ChatForm.interface";
import ChatFormTab from "../../components/chat-form-tabs/FormTab";
import ChatMapTab from "../../components/chat-form-tabs/MapTab";
import ChatFileTab from "../../components/chat-form-tabs/FileTab";
import api from "../../api/axios";
import InfoPopup from "../../components/InfoPopup";
import { clientDataStatuses, type ILeadData } from "../../App.interface";

const ChatForm = ({ phone }: IChatFormProps) => {
  const [activeTab, setActiveTab] = useState<ChatFormTabs>("form");

  const [formData, setFormData] = useState<ILeadData>({
    stage: "",
    age: "",
    citizenship: null,
    city: null,
    ka: null,
    lastName: "",
    firstName: "",
    middleName: "",
    dateOfBirth: "",
    education: null,
    contractType: null,
    role: null,
    contractDate: "",
    educationDateTime: "",
    educationCenter: null,
    inn: "",
    insuranceNumber: "",
    transportType: null,
    foreignCitizen: false,
    minor: false,
    office: false,
    preFilledFCForm: false,
    rejectionReason: null,
    reservationReason: null,
    company: null,
    region: null,
    hireType: null,
    sex: null,
  });

  const [leadId, setLeadId] = useState<number | null>(null);

  const [contactId, setContactId] = useState<number | null>(null);

  const [showPopup, setShowPopup] = useState<boolean>(false);

  const [message, setMessage] = useState<string>("");

  const [clientDataStatus, setClientDataStatus] = useState<
    (typeof clientDataStatuses)[keyof typeof clientDataStatuses]
  >(clientDataStatuses.loading);

  const getClientData = async (phone: string) => {
    try {
      const { data } = await api.get<IClientData>("/api-gateway/lead", {
        params: { phone },
      });
      console.log(`Данные успешно получены`);
      setFormData(data.leadData);
      setLeadId(data.leadId);
      setContactId(data.contactId);
      setClientDataStatus(clientDataStatuses.found);
      return true;
    } catch (error) {
      console.log(`Не удалось получить данные: ${error}`);
      setMessage(`Активная сделка по контакту не найдена`);
      setShowPopup(true);
      setClientDataStatus(clientDataStatuses.notFound);
      return false;
    }
  };

  const kaForFileUpload = ["Изи Лоджистик", "ИЗИ"];

  const isFileUploadRequired = (): boolean => {
    const ka = formData.ka?.value.toLocaleLowerCase();
    const requiredKa = kaForFileUpload.map((kaItem) =>
      kaItem.toLocaleLowerCase(),
    );
    if (ka && requiredKa.includes(ka)) return true;
    return false;
  };

  useEffect(() => {
    if (phone) getClientData(phone);
  }, []);

  if (clientDataStatus === clientDataStatuses.loading) {
    return <p>Поиск сделки...</p>;
  }

  if (clientDataStatus === clientDataStatuses.notFound) {
    return (
      <>
        {showPopup && (
          <InfoPopup
            message={message}
            onClose={() => setShowPopup(false)}
          ></InfoPopup>
        )}
      </>
    );
  }

  return (
    <div className="chat-form">
      <div className="header">
        <button
          className={`form-button ${
            activeTab === "form" ? "tab active" : "tab"
          }`}
          onClick={() => setActiveTab("form")}
        >
          Анкета
        </button>
        <button
          className={`map-button ${activeTab === "map" ? "tab active" : "tab"}`}
          onClick={() => setActiveTab("map")}
        >
          Карта потребностей
        </button>
        <button
          className={`file-button ${
            activeTab === "file" ? "tab active" : "tab"
          }`}
          onClick={() => setActiveTab("file")}
          disabled={!isFileUploadRequired()}
        >
          Загрузка документов
        </button>
      </div>

      <div style={{ display: activeTab === "form" ? "block" : "none" }}>
        <ChatFormTab
          phone={phone}
          leadId={leadId}
          contactId={contactId}
          incomingFieldValues={formData}
        ></ChatFormTab>
      </div>
      <div style={{ display: activeTab === "map" ? "block" : "none" }}>
        <ChatMapTab></ChatMapTab>
      </div>
      <div style={{ display: activeTab === "file" ? "block" : "none" }}>
        <ChatFileTab leadId={leadId}></ChatFileTab>
      </div>
    </div>
  );
};

export default ChatForm;
